export function getLayout3SceneTitle(sceneId?: string, sceneName?: string): string {
  const normalizedSceneId = (sceneId || '').trim().toLowerCase();

  if (normalizedSceneId === 'luxiaoke' || normalizedSceneId === 'luxiake') {
    return '平果市科技馆';
  }

  return (sceneName || '').trim();
}

export function getLayout3SceneTitleImage(sceneId?: string): string {
  const normalizedSceneId = (sceneId || '').trim().toLowerCase();

  if (normalizedSceneId === 'luxiaoke' || normalizedSceneId === 'luxiake') {
    return '/luxiaoke-science-museum-title.png';
  }

  return '';
}
